import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import ContainerCell from './WeightSumCell';

class CaloriesSumRow extends React.Component {
  render() {
    const { classes, mealTypeSizes, dishSizes, rowType, t } = this.props;

    return (
      <TableRow>
        <TableCell>{t('mealParams.productWeight', 'Masa produktu')}</TableCell>
        <TableCell />
        <TableCell />
        {mealTypeSizes.map((mealTypeSize, mealTypeSizeKey) => (
          <ContainerCell
            rowType={rowType}
            key={mealTypeSizeKey}
            classes={classes}
            size={mealTypeSize.size}
            mealTypeSize={mealTypeSize}
            dishSizes={dishSizes}
          />
        ))}
      </TableRow>
    );
  }
}

export default CaloriesSumRow;
